import { AptosStoreCreditMode } from "@redotech/redo-integrations-definitions-common/integrations/aptos-settings";
import * as z from "zod";

/** Returns write-back settings; every switch defaults off on the integration. */
const aptosReturnsSettingsSchema = z.object({
  exchangeOrdersEnabled: z.boolean(),
  exchangeOrderPaymentType: z.string().nullable(),
  exchangeOrderUpdateInventory: z.boolean(),
  exchangeOrderShipCode: z.string().nullable(),
  exchangeOrderShippingId: z.string().nullable(),
  exchangeOrderSupplierCode: z.string().nullable(),
  refundsEnabled: z.boolean(),
  refundCreditType: z.string().nullable(),
  refundReasonCode: z.string().nullable(),
  storeCreditMode: z.nativeEnum(AptosStoreCreditMode),
  storeCreditType: z.string().nullable(),
});

export type AptosReturnsSettings = z.infer<typeof aptosReturnsSettingsSchema>;

export const setAptosIntegration = {
  name: "setAptosIntegration" as const,
  input: z.object({
    clientName: z.string().min(1, "Client name is required"),
    guid: z.string().min(1, "Guid is required"),
    endpointUrl: z.string().url("A valid OrderService URL is required"),
  }),
  output: z.object({}),
};

export type SetAptosIntegrationInput = z.infer<
  typeof setAptosIntegration.input
>;

export const updateAptosIntegration = {
  name: "updateAptosIntegration" as const,
  input: z.object({
    clientName: z.string().min(1).optional(),
    guid: z.string().min(1).optional(),
    endpointUrl: z.string().url().optional(),
    enabled: z.boolean().optional(),
    returnsSettings: aptosReturnsSettingsSchema.partial().optional(),
  }),
  output: z.object({}),
};

export type UpdateAptosIntegrationInput = z.infer<
  typeof updateAptosIntegration.input
>;

export const getAptosIntegration = {
  name: "getAptosIntegration" as const,
  input: z.object({}),
  output: z.object({
    aptosIntegration: z.optional(
      z.object({
        clientName: z.string(),
        endpointUrl: z.string().nullable(),
        enabled: z.boolean(),
        ordersSyncAt: z.date().nullable(),
        ordersLiveSyncedAt: z.date().nullable(),
        ordersBackfilled: z.boolean(),
        returnsSettings: aptosReturnsSettingsSchema,
      }),
    ),
  }),
};

export type GetAptosIntegrationOutput = z.infer<
  typeof getAptosIntegration.output
>;

export const disconnectAptosIntegration = {
  name: "disconnectAptosIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
